import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { cartApi } from "../api/cartApi";
import { orderApi } from "../api/orderApi";
import { accountApi } from "../api/accountApi";
import Message from "../components/Message";

export default function Checkout({ onCheckout }) {
  const [form, setForm] = useState({ address: "", city: "", zip_code: "" });
  const [cart, setCart] = useState({ items: [], total: 0 });
  const [notice, setNotice] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    accountApi.getAccount().then((data) => {
      const user = data.user || data;
      setForm({
        address: user.address || "",
        city: user.city || "",
        zip_code: user.zip_code || "",
      });
    }).catch(() => {});

    cartApi.getCart().then((data) => {
      setCart({ items: data.cart_items || data.items || [], total: data.total || 0 });
    }).catch((error) => setNotice({ type: "error", text: error.message }));
  }, []);

  function updateField(event) {
    setForm((current) => ({ ...current, [event.target.name]: event.target.value }));
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setSubmitting(true);

    try {
      // Checkout now creates a saved order; payment is completed from the order page.
      const data = await orderApi.checkout(form);
      if (onCheckout) {
        onCheckout();
      }
      navigate(`/order-tracking/${data.order_id}`, {
        state: { notice: "Order saved. Select a saved payment method to pay." },
      });
    } catch (error) {
      setNotice({ type: "error", text: error.message });
      setSubmitting(false);
    }
  }

  return (
    <div className="checkout-container">
      <div className="container">
        <h1 className="page-title">Checkout</h1>
        <Message notice={notice} />

        <div className="checkout-content">
          <div className="checkout-form">
            <h2>Delivery Address</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="address">Street Address</label>
                <input type="text" id="address" name="address" value={form.address} onChange={updateField} required className="form-control" />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="city">City</label>
                  <input type="text" id="city" name="city" value={form.city} onChange={updateField} required className="form-control" />
                </div>
                <div className="form-group">
                  <label htmlFor="zip_code">ZIP Code</label>
                  <input type="text" id="zip_code" name="zip_code" value={form.zip_code} onChange={updateField} required className="form-control" />
                </div>
              </div>

              <button type="submit" className="btn btn-primary btn-block" disabled={submitting} style={{ marginTop: 20 }}>
                {submitting ? "Saving Order..." : "Create Saved Order"}
              </button>
            </form>
          </div>

          <div className="order-summary">
            <h2>Order Summary</h2>
            <div className="summary-items">
              {cart.items.map((item) => (
                <div className="summary-item" key={item.product_id}>
                  <span>{item.name} x{item.quantity}</span>
                  <span>${(Number(item.price) * Number(item.quantity)).toFixed(2)}</span>
                </div>
              ))}
            </div>
            <div className="summary-total">
              <strong>Total: ${Number(cart.total).toFixed(2)}</strong>
            </div>
            <p className="security-note" style={{ marginTop: 16 }}>
              Payment is completed after the order is saved.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
